export default __webpack_public_path__ + "static/media/dan.8f516f7a.jpg";